import { useNavigate, useParams } from "react-router-dom"
import "./ViewEvent.css"
import MiddleBlock from "../../components/MiddleBlock/MiddleBlock"
import { getEventByID, loadGalleryByID } from "../../api/api"
import FullEventBlock from "./components/FullEventBlock/FullEventBlock"
import { useEffect, useState } from "react"
import SectionHeader from "../../components/SectionHeader/SectionHeader"
import Pagination from "../../components/elements/Pagination/Pagination"
import Lightbox from "../../components/elements/Lightbox/Lightbox"
import { formatDate } from "../../utils/formatDate"
import Loader from "../../components/elements/Loader/Loader"
import EmptyState from "../../components/elements/EmptyState/EmptyState"

export default function ViewEvent() {
    const { id } = useParams()
    const [event, setEvent] = useState(null)
    const [allGalleryImages, setAllGalleryImages] = useState([]);
    const [displayedImages, setDisplayedImages] = useState([]);
    const [galleryLoading, setGalleryLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 9;
    const navigate = useNavigate()

    useEffect(() => {
        async function loadEvent() {
            try {
                const data = await getEventByID(id);
                setEvent(data);
                
                if (data.links) {
                    try {
                        const parsedLinks = JSON.parse(data.links);
                        console.log('Rozparsowane linki:', parsedLinks);
                        
                        const instagram = parsedLinks.find(l => l.name === 'instagram')?.link || '';
                        const facebook = parsedLinks.find(l => l.name === 'facebook')?.link || '';
                        const phone_nubmer = parsedLinks.find(l => l.name === 'phone')?.link || '';
                        
                        setEvent(prev => ({
                            ...prev,
                            instagram,
                            facebook,
                            phone_nubmer,
                            links: parsedLinks
                        }));
                    } catch (e) {
                        console.log('Błąd parsowania linków:', e);
                    }
                }
                
                console.log('Załadowane wydarzenie:', data);
            } catch (error) {
                console.log('Błąd:', error);
            } finally {
            }
        }
        loadEvent();
    }, [id, navigate])

    useEffect(() => {
        async function loadGallery() {
            setGalleryLoading(true);
            try {
                const response = await loadGalleryByID(id);
                
                if (response.success && response.data) {
                    const images = response.data.map(img => ({
                        id: img.id,
                        path: img.image_path,
                        caption: img.caption || '',
                        sort_order: img.sort_order || 0,
                    }));
                    
                    setAllGalleryImages(images);
                    setTotalPages(Math.ceil(images.length / itemsPerPage));
                    console.log(`📸 Załadowano ${images.length} obrazów dla wydarzenia ${id}`);
                } else {
                    setAllGalleryImages([]);
                    setTotalPages(1);
                    console.log('📸 Brak obrazów dla tego wydarzenia');
                }
            } catch (error) {
                console.error('❌ Błąd ładowania galerii:', error);
                setAllGalleryImages([]);
                setTotalPages(1);
            } finally {
                setGalleryLoading(false);
            }
        }
        
        loadGallery();
    }, [id]);

    useEffect(() => {
        const startIndex = (page - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const imagesForPage = allGalleryImages.slice(startIndex, endIndex);
        setDisplayedImages(imagesForPage);
        
        const galleryElement = document.querySelector('.view-event-gallery-grid');
        if (galleryElement) {
            galleryElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [page, allGalleryImages]);

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    if (!event) return <Loader />

    let hex = {
        background: "#290401",
        primary: "#EAD9CB",
        secondary: "#F9C49A"
    };
    
    if (event.colors) {
        try {
            hex = typeof event.colors === 'string' 
                ? JSON.parse(event.colors) 
                : event.colors;
        } catch (e) {
            console.log('Błąd parsowania kolorów:', e);
        }
    }

    return (
        <>
            <MiddleBlock>
                <FullEventBlock
                    id={event.id}
                    title={event.title}
                    description={event.full_description}
                    date={formatDate(event?.event_date)}
                    image={event.image}
                    imagePosition={event.image_position}
                    imagePositionMobile={event.image_position_mobile}
                    hex={hex}
                    fontSizeDescription={event.font_size_full_description || 20}
                    actionType="view"
                    links={ event.links }
                    style={{ marginTop: "clamp(36px, 8vw, 100px)" }}
                />
            </MiddleBlock>
            
            <SectionHeader>Galeria</SectionHeader>
            <MiddleBlock>
                {galleryLoading ? (
                    <div className="gallery-loading">Ładowanie galerii...</div>
                ) : (
                    <>
                        {allGalleryImages.length > 0 ? (
                            <>                                
                                <div className="view-event-gallery-grid">
                                    <Lightbox>
                                        {displayedImages.map((image, index) => (
                                            <div key={image.id || index} className="view-event-gallery-item">
                                                <div className="view-event-gallery-image-wrapper">
                                                    <img 
                                                        src={image.path} 
                                                        alt={image.caption || `Obraz ${(page - 1) * itemsPerPage + index + 1}`}
                                                        className="view-event-gallery-image"
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </Lightbox>
                                </div>

                                {totalPages > 1 && (
                                    <Pagination 
                                        currentPage={page}
                                        totalPages={totalPages}
                                        onPageChange={handlePageChange}
                                        showInfo={true}
                                        size="md"
                                    />
                                )}
                            </>
                        ) : (
                            <EmptyState type="gallery" title="Brak zdjęć z tego wydarzenia">
                                Gdy pojawią się nowe materiały, znajdziesz je właśnie tutaj.
                            </EmptyState>
                        )}
                    </>
                )}
            </MiddleBlock>
        </>
    )
}
